import { Controller } from "../controls/controller";
import { GameState } from "../state/game-state";
import { MenuManager } from "./menu-manager";

const createMenuTitleLi = (title: string | null, parent: HTMLElement) => {
  if (!title) return null;
  const li = document.createElement("li");
  li.textContent = title;
  li.classList.add("menu-item", "menu-title");
  parent.appendChild(li);
  return li;
};

const createLi = (display: string, parent: HTMLElement) => {
  const li = document.createElement("li");
  li.textContent = display;
  li.classList.add("menu-item");
  parent.appendChild(li);
  return li;
};

const createUl = (parent: HTMLElement) => {
  const ul = document.createElement("ul");
  ul.classList.add("menu-list");
  parent.appendChild(ul);
  return ul;
};

export class TextMenu {
  private selected: number = 0;
  private listElement?: HTMLElement;
  private listItems?: HTMLElement[];

  constructor(
    private container: HTMLElement,
    private menuTitle: string | null,
    private items: {
      display: string;
      action: (ctx?: {
        gameState: GameState;
        menuManager: MenuManager;
        controller: Controller;
      }) => void;
    }[],
  ) {}

  show() {
    this.listElement = createUl(this.container);
    if (!this.listElement) return;

    createMenuTitleLi(this.menuTitle, this.listElement);
    this.listItems = this.items.map((item) => {
      return createLi(item.display, this.listElement!);
    });
    this.setSelectedIdx(this.selected);
  }

  remove() {
    if (!this.listElement) return;
    this.container.removeChild(this.listElement);
    this.listElement = undefined;
    this.listItems = undefined;
  }

  private setSelectedIdx(idx: number) {
    if (!this.listItems) return;

    this.selected = idx;
    this.listItems.forEach((li, i) => {
      if (i === idx) {
        li.classList.add("selected");
      } else {
        li.classList.remove("selected");
      }
    });
  }

  up() {
    if (!this.listItems) return;
    this.setSelectedIdx(
      (this.selected + this.listItems.length - 1) % this.listItems.length,
    );
  }

  down() {
    if (!this.listItems) return;
    this.setSelectedIdx((this.selected + 1) % this.listItems.length);
  }

  activate(ctx?: {
    gameState: GameState;
    menuManager: MenuManager;
    controller: Controller;
  }) {
    if (!this.listItems) return;
    this.items[this.selected].action(ctx);
  }
}
